import { render, staticRenderFns } from "./LogSummaryCard.vue?vue&type=template&id=6237948c&scoped=true"
import script from "./LogSummaryCard.vue?vue&type=script&lang=js"
export * from "./LogSummaryCard.vue?vue&type=script&lang=js"
import style0 from "./LogSummaryCard.vue?vue&type=style&index=0&id=6237948c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6237948c",
  null
  
)

export default component.exports